import { Grid, Paper, makeStyles, Theme, createStyles, useTheme, FormControl, InputLabel, Select, MenuItem, Typography,
    TextField, Button, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, withStyles, Fab, useMediaQuery } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import Main from '../../components/main';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { useEffect, useCallback, ChangeEvent } from 'react';
import { getCompanies } from '../../services/companyServices';
import { CompanySearchModel, Company } from '../../models/company';
import { Applicazioni, TelematicoData } from '../../types/types';
import {useHistory} from 'react-router-dom';
import 'react-dropzone-uploader/dist/styles.css'
import SearchIcon from '@material-ui/icons/Search';
import {ClearIcon} from '../../icons/icons';
import Dropzone from 'react-dropzone-uploader';
import { importTelematico, getTelematicos } from '../../services/telematicoService';
import { getAgencies } from '../../services/agencyService';
import { AgencySearchModel, Agency } from '../../models/agency';
import { useLogger } from '../../logger';
import TablePaginationActions from '../../pagination/TablePaginationActions';
import { motion } from 'framer-motion';
import { TelematicoSearchModel, Telematico } from '../../models/telematico';
import { Autocomplete, AutocompleteChangeReason } from '@material-ui/lab';
import { breakpoint } from '../../types/constants';
import { Roles } from '../../models';
import { NumberField } from '../../components/NumberField';

const useStyles = makeStyles((theme: Theme) => createStyles({
    filterContainer: {
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(0),
        display: 'flex',
    },
    filterTitle: {
        flex: '0 1 auto', 
        // paddingTop: '12px'        
    },
    fab: {
        textAlign: 'right'
    },
    formControl: {
        marginTop: '4px',
        minWidth: 150
    },
    tableContainer: {
        width: "100%",
        marginTop: theme.spacing(3),
        overflowX: "auto",
    },
    table: {
        minWidth: 700,
    },
    tablerow: {
        cursor: 'pointer',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
        // background: '#d5d4d9a8',
        borderRadius: '7px'
    },
}));
  
const CustomTableCellForIcon = withStyles((theme: Theme) => createStyles({
    body: {
        fontSize: 20,
        textAlign: 'center',
        color: theme.palette.secondary.main,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(0.25),
        paddingBottom: theme.spacing(0),
        borderLeft: 'solid 1px #c0c0c0'
    },
}))(TableCell);
const CustomTableCell = withStyles((theme: Theme) => createStyles({
    head: {
        fontSize: 14,
        // backgroundColor: theme.palette.common.black,
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
        paddingLeft: theme.spacing(1),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        borderLeft: 'solid 1px #c0c0c0',
    },
    body: {
        fontSize: 14,
        paddingLeft: theme.spacing(1),
        paddingTop: theme.spacing(0.25),
        paddingBottom: theme.spacing(0.25),
        borderLeft: 'solid 1px #c0c0c0'
    },
}))(TableCell);
const CustomTableRow = withStyles((theme: Theme) => createStyles({
    root: {
        color: "inherit",
        display: "table-row",
        outline: "none",
        verticalAlign: "middle",
        height: 28,
    },
}))(TableRow);
  
export default function ImportTelematicoIndex() {
    const theme = useTheme();
    const classes = useStyles();
    const gClasses = globalStyles();
    const [auth,] = useGlobal<IGlobalState, 'auth'>('auth')
    const[identity,] = useGlobal<IGlobalState, 'identity'>('identity');
    const[ip] = useGlobal<IGlobalState, 'ip'>('ip');
    const[companies, setCompanies] = useGlobal<IGlobalState, 'companies'>('companies');
    const[, setApplication] = useGlobal<IGlobalState, 'application'>('application');
    let title: string = 'Import telematico';
    const history = useHistory();
    const[file, setFile] = React.useState<File>();
    const [globalWait, setGlobalWait]= useGlobal<IGlobalState, 'globalWait'>('globalWait');
    const [agencies, setAgencies] = React.useState<Agency[]>([]);
    const [companyId, setCompanyId] = React.useState<number>();
    const [agency, setAgency] = React.useState<Agency | null>(null);
    const [telematicoType, setTelematicoType] = React.useState<string | null>(null);
    const [taxCode, setTaxCode] = React.useState<string>();    
    const [year, setYear] = React.useState<number | null>(null);    
    const [filteredTelematico, setFilteredTelematico] = useGlobal<IGlobalState, 'filteredTelematico'>('filteredTelematico');
    const [loadingTelematico, setLoadingTelematico] = useGlobal<IGlobalState, 'loadingTelematico'>('loadingTelematico');
    const logger = useLogger({key: 'telematico'});
    const [pagination, setPagination] = useGlobal<IGlobalState, 'companyPagination'>('companyPagination');
    const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));
    let model: TelematicoSearchModel = new TelematicoSearchModel();
    const _handleChangePage = (ev: React.MouseEvent<HTMLButtonElement> | null, page: number) => setPagination({...pagination, page});
    const _handleChangeRowsPerPage = (ev: React.ChangeEvent<HTMLTextAreaElement|HTMLInputElement>) => setPagination({...pagination, rowsPerPage: parseInt(ev.target.value)})
    
    const loadCompanies = async () => {
        let model = new CompanySearchModel();
        if (identity?.CompanyId) {
            console.log('identity ha una company');
            model.Id = identity?.CompanyId;
        }
        model.ImportEnabled = true;
        let companyList = await getCompanies(ip, auth.authData!, auth.user!, model);
        console.log('Carico le Company: ' + companyList.length);
        setCompanies(companyList);
    }
    
    const loadAgencies = async (value: number) => {
        let model = new AgencySearchModel();
        model.CompanyId = value;
        if (identity?.PrincipalAuth[0] && identity?.PrincipalAuth[0].AgencyId){
            model.Id = identity?.PrincipalAuth[0].AgencyId;
        }
        let res = await getAgencies(ip, auth.authData!, auth.user!, model);
        setAgencies(res?.ResultList);
    }
    
    const handleChangeSelectCompany = (e: any) => {
        let { name, value } = e.target;
        setCompanyId(value);
        loadAgencies(value);
    }
    
    const handleChangeSelectAgency = (event: ChangeEvent<{}>, value: Agency | null, reason: AutocompleteChangeReason) => {
        // let { name, value } = e.target;
        console.log('agency id: ' + value?.Id);
        setAgency(value);
    }
    
    const handleChangeSelectType = (e: any) => {
        let { name, value } = e.target;
        console.log('type id: ' + value);
        setTelematicoType(value);
    }

    const handleChangeTaxCode = (e: any) => {
        let { name, value } = e.target;
        console.log('taxcode: ' + value);
        setTaxCode(value);
    }
    const handleChangeYear = (e: any) => {
        let { name, value } = e.target;
        console.log('year: ' + value);
        setYear(value);
    }

    const handleSearch = () => {
        setLoadingTelematico(true);
        model.CompanyId = companyId!;
        model.AgencyId = agency ? agency.Id : null;
        console.log('type: ' + telematicoType)
        console.log('taxCode: ' + taxCode)
        model.TelematicoType = telematicoType;
        model.TaxCodeDichiarante = taxCode;
        model.Year = year !== 0 ? year : null;
        getTelematicos(ip, auth.authData!, auth.user!, model).then(res => {
            console.log('Ritorno le telematico ' + JSON.stringify(res));            
            setFilteredTelematico(res as Telematico[]);
            // history.push(`/companyDetail/${company.Id}`);
        }).catch(error => {
            logger.error('Errore in recupero telematico: ' + error.statusText);
        })
        .finally(() => setLoadingTelematico(false));
    }
    
    const handleClear = () => {
        console.log('clear filter')
        setTaxCode("");
        setTelematicoType(null);
        if (agencies && agencies.length > 1) {
            setAgency(null);
        }
        setYear(0);
    }

    const getUploadParams = ({ file, meta }) => {
        const body = new FormData()
        body.append('files', file)
        console.log('getUploadParams' + {file});
        // Salvo il file nello stato
        setFile(file);
        return { url: 'https://httpbin.org/post', body }
        // return { url: "", body }
    }

    const handleChangeStatus = ({ meta, remove }, status) => {        
        console.log(status, meta);
        if (status === 'headers_received') {
            // logger.info('importazione conclusa con Successo', "Import Telematico")
            // remove();
        } else {
            // logger.error('Errore in importazione dati da telematico', "Import Telematico");          
        }
    }
    
    const loadFile = (f: File) => {
        if (!file) {
            return;
        }
        setGlobalWait(true);
        let metadata: TelematicoData = {CompanyId: 0, AgencyId: null, Username: auth.authData?.user!, FileName: f.name}
        metadata.CompanyId = companyId!;
        metadata.AgencyId = agency ? agency.Id : null;
        importTelematico(ip, auth.authData!, auth.user!, metadata, f).then(result => {
            if (result === true) {
                logger.info('importazione conclusa con Successo', "Import Telematico")
            }
            else {
                logger.error('Errore in importazione dati da telematico', "Import Telematico");          
            }
            setGlobalWait(false);
        })
        .catch(error => {
            logger.error(error.statusText, "Import Telematico");                      
        })
        .finally(() => setGlobalWait(false))
    }
    
    const handleSubmit = (files, allFiles) => {
        // console.log(files.map(f => f.meta))
        // allFiles.forEach(f => {
        //     // f.remove()
        //     console.log('HandleSubmit file: ' + f.length);
        // });
        if (identity?.Role !== Roles.SUPERADMIN && !agency) {
            logger.error('Scegliere studio di competenza', 'IMPORT TELEMATICO');
            return;
        }
        loadFile(file!);
    }
    
    // const onDrop = useCallback((acceptedFiles) => {
    //     acceptedFiles.forEach((file) => {
    //         const reader = new FileReader()
            
    //         reader.onabort = () => console.log('file reading was aborted')
    //         reader.onerror = () => console.log('file reading has failed')
    //         reader.onload = () => {
    //             // Do whatever you want with the file contents
    //             const binaryStr = reader.result
    //             console.log(binaryStr)
    //         }
    //         reader.readAsArrayBuffer(file)
    //     })
    //     loadFiles(acceptedFiles)        
    // }, [])
    // const {getRootProps, getInputProps} = useDropzone({onDrop})    
    
    useEffect(() => {
        loadCompanies();
        setApplication(Applicazioni.ImportTelematico);
        //Pre imposto la Company
        if (identity?.CompanyId) {
            setCompanyId(identity?.CompanyId);
            loadAgencies(identity?.CompanyId)
        }
        if (identity?.PrincipalAuth && identity?.PrincipalAuth[0]) {
            setAgency(identity?.PrincipalAuth[0]?.Agency);
        }
    },[]);

    return (
      <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
        <IForfettariAppBar title="IForfetari" handleLoad={() => {}} handleChange={() =>{}}></IForfettariAppBar>
        <Main>
        <div className={gClasses.rootModel}>
            <motion.div
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                transition={{ delay: 0.5, duration: 1.5}}
                style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start',  flex: '0 1 auto'}}                    
            >
            <Grid container >
                <div className={classes.filterTitle}>
                    <h3>
                        Filtri
                    </h3>
                </div>
                &nbsp;
                <Grid item lg={2} xs={12}>
                        <InputLabel htmlFor="company">Company</InputLabel>
                        <Select
                            className={gClasses.select}
                            value={identity?.CompanyId ? identity?.CompanyId : companyId}
                            onChange={handleChangeSelectCompany}
                            inputProps={{
                                name: 'company',
                                id: 'companyId',
                            }}
                            >
                            {companies.map((item: Company, keyIndex: number) => {
                                return (
                                <MenuItem key={keyIndex.toString()} value={item.Id}>
                                    {item.BusinessName}
                                </MenuItem>
                                )                    
                            })
                            }
                        </Select>
                </Grid>
                <Grid item lg={3} xs={12}>
                    {/* <InputLabel htmlFor="agency">Studio</InputLabel> */}
                    <Autocomplete
                        className={gClasses.selectLong}
                        value={agency}
                        // inputValue={agency ? agency.Name : ""}
                        // defaultValue={agencies.find(v => v.Name[0])}
                        options={agencies}
                        getOptionLabel={(option: Agency) => option.Name}
                        onChange={handleChangeSelectAgency}
                        renderInput={(params) => <TextField {...params} label="Studio" />}
                    />
                </Grid>
                <Grid item lg={2} xs={12}>
                    <InputLabel htmlFor="telematico">Tipo telematico</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={telematicoType}
                        onChange={handleChangeSelectType}
                        displayEmpty={true}
                        inputProps={{
                            name: 'telematicoType',
                            id: 'telematicoType',                                
                        }}                            
                        >
                            {/* <MenuItem aria-label="None" value=""></MenuItem> */}
                            <MenuItem value="PF">Persona fisica</MenuItem>
                            <MenuItem value="SC">Società</MenuItem>
                    </Select>
                </Grid>
                <Grid item lg={2} xs={12}>
                    <InputLabel htmlFor="taxCode">Codice fiscale</InputLabel>
                    <TextField
                        // required
                        // error={error}
                        // helperText="Ricerca per codice fiscale"
                        id="taxCode"
                        name="taxCode"
                        value={taxCode}
                        onChange={handleChangeTaxCode}
                        // label="Codice fiscale" 
                        // onBlur={handleBlur}
                        // className={gClasses.textField}
                        InputLabelProps={{
                            shrink: true,            
                        }}
                        // margin="dense"
                    />
                </Grid>
                <Grid item lg={2} xs={12}>
                    <InputLabel htmlFor="taxCode">Anno dich</InputLabel>
                    <NumberField
                        // required
                        // error={error}
                        // helperText="Ricerca per codice fiscale"
                        id="year"
                        name="year"                        
                        value={year}
                        onChange={handleChangeYear}
                        // label="Anno dichiarativo"
                        symbol=""
                        denyFormat={true}
                        // onBlur={handleBlur}
                        className={classes.textField}
                        // margin="dense"
                    />
                </Grid>
                &nbsp;
                <div style={{ flex: '0 1 auto', paddingTop: '10px' }}>
                    <Fab color='default' size='small' className={classes.fab} title="Pulisci"
                        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleClear()}>
                        <ClearIcon />
                    </Fab>
                </div>
                &nbsp;
                <div style={{ flex: '0 1', paddingTop: '10px' }}>
                    {/* <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleAdd()}><AddIcon /></Fab> */}
                    <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleSearch()}>
                        <SearchIcon titleAccess="Ricerca company"/>
                    </Fab>
                </div>
            </Grid>                    
            </motion.div>            
            <Dropzone
                getUploadParams={getUploadParams}
                onChangeStatus={handleChangeStatus}
                onSubmit={handleSubmit}
                maxFiles={1}
                // canCancel={false}
                styles={{ dropzone: { minHeight: 150, maxHeight: 250, marginTop: '3px' } }}
                submitButtonContent="Importa"
                inputContent="Trascina qui il tuo file o clicca per selezionarlo"
                // accept='.dcm|.*'
            />
            <Paper className={classes.tableContainer}>
            <Table className={classes.table} size='small'>
                <TableHead>
                    <TableRow>
                        <CustomTableCell>Anno Dichiarativo</CustomTableCell>
                        <CustomTableCell>Codice Fiscale/P.Iva</CustomTableCell>
                        <CustomTableCell>Tipo telematico</CustomTableCell>
                        <CustomTableCell>Company</CustomTableCell>
                        <CustomTableCell>Studio</CustomTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {!loadingTelematico && filteredTelematico && filteredTelematico.length 
                    ? (filteredTelematico.slice(pagination.page * pagination.rowsPerPage, pagination.page * pagination.rowsPerPage + pagination.rowsPerPage).map(telamatico => (
                        <TableRow hover={true} key={telamatico.Id} className={classes.tablerow}>
                            <CustomTableCell>{telamatico.Year}</CustomTableCell>
                            <CustomTableCell>{telamatico.TaxCodeDichiarante}</CustomTableCell>
                            <CustomTableCell>{telamatico.TelematicoType}</CustomTableCell>
                            <CustomTableCell>{telamatico.DescCompany}</CustomTableCell>
                            <CustomTableCell>{telamatico.DescAgency}</CustomTableCell>
                        </TableRow>
                    ))) 
                    : <CustomTableRow>
                        <CustomTableCell colSpan={5}>
                            <Typography variant="h6" color="textSecondary">{loadingTelematico ? "Caricamento..." : "Nessun dato da visualizzare"}</Typography>
                        </CustomTableCell>
                    </CustomTableRow>
                }
                </TableBody>
                <TableFooter>
                    <CustomTableRow>
                        <CustomTableCell colSpan={6}>
                            <TablePagination
                                rowsPerPageOptions={[10,20,30]}
                                count={filteredTelematico ? filteredTelematico.length : 0}
                                rowsPerPage={pagination.rowsPerPage}
                                page={pagination.page}
                                SelectProps={{native: false,}}
                                onChangePage={_handleChangePage}
                                onChangeRowsPerPage={_handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                                labelRowsPerPage="Righe per pagina"
                                labelDisplayedRows={({ from, to, count }) => count ? `${from}-${to} di ${count}` : ""}
                                component='div'
                                style={{display: 'flex'}}
                            />
                        </CustomTableCell>
                    </CustomTableRow>
                </TableFooter>
            </Table>
            </Paper>
        </div>
        </Main>
      </div>
    );
}